export default "__VITE_ASSET__C4YRdU2R__"